import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';
import { logger } from '../shared/logging/logger';
import { normalizeQueryError } from './query-log';

// TanStack Query — the shared server-state cache for the app.
//
// The src/api/* functions remain the HTTP source of truth (axios + the
// interceptor in src/api/http.ts: retry, recovery, toasts, loader bar). Query
// and mutation hooks wrap those functions; this client just provides the cache
// (dedup, caching by key, background refetch) and centralized observability.
//
// Observability: the QueryCache/MutationCache handlers below route EVERY
// query/mutation success and error into the diagnostic logger under the 'query'
// category, so a downloaded .log shows exactly what fetched, what failed, the
// status code, and how many retries it took. onError LOGS ONLY — the axios
// interceptor remains the single source of user-facing error UI (toasts /
// navigate-home), so we do not double-notify.
export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      logger.error('query', 'query error', {
        key: query.queryKey,
        failureCount: query.state.fetchFailureCount,
        ...normalizeQueryError(error),
      });
    },
    onSuccess: (_data, query) => {
      logger.info('query', 'query success', { key: query.queryKey });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _vars, _ctx, mutation) => {
      logger.error('query', 'mutation error', {
        key: mutation.options.mutationKey,
        ...normalizeQueryError(error),
      });
    },
    onSuccess: (_data, _vars, _ctx, mutation) => {
      logger.info('query', 'mutation success', { key: mutation.options.mutationKey });
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});
